export const restaurantListOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  searchShow: false,
  searchBtn: false,
  refreshBtn: false,
  columnBtn: false,
  menu: false,
  addBtn: false,
  delBtn: false,
  editBtn: false,
  viewBtn: false,
  searchBtn: false,
  column: [
    {
      label: '区域',
      prop: 'regionName',
      editDisabled: true,
    },
    {
      label: '市场',
      prop: 'marketName',
      editDisabled: true,
    },
    {
      label: '总经理',
      prop: 'gmName',
      editDisabled: true,
      width: '100px',
    },
    {
      label: '营运总监',
      prop: 'doName',
      editDisabled: true,
      width: '100px',
    },
    {
      label: '营运经理',
      prop: 'omName',
      editDisabled: true,
      width: '100px',
    },
    {
      label: '营运顾问',
      prop: 'ocName',
      editDisabled: true,
      width: '100px',
    },
    {
      label: '餐厅国际编号',
      prop: 'storeCode',
      editDisabled: true,
    },
    {
      label: '餐厅名称',
      prop: 'storeName',
      editDisabled: true,
    },
    {
      label: '比拼岗位',
      prop: 'positionName',
      editDisabled: true,
      width: '100px',
    },
    {
      label: '员工编号',
      prop: 'unionId',
      editDisabled: true,
      width: '100px',
    },
    {
      label: '员工姓名',
      prop: 'nickname',
      editDisabled: true,
      width: '100px',
    },
    {
      label: '身份',
      prop: 'identity',
      editDisabled: true,
    },
    {
      label: '总分（技能得分+速度得分）',
      prop: 'totalScore',
      editDisabled: true,
      width: '130px',
    },
    {
      label: '技能得分',
      prop: 'positionScore',
      editDisabled: true,
    },
    {
      label: '速度得分',
      prop: 'serviceScore',
      editDisabled: true,
    },
    {
      label: '服务速度',
      prop: 'serviceSpeed',
      editDisabled: true,
    },
    {
      label: '总排名',
      prop: 'rankInStore',
      editDisabled: true,
    },
    {
      label: '裁判',
      prop: 'judgmentName',
      editDisabled: true,
      width: '100px',
    },
    {
      label: '录入时间',
      prop: 'signUpTime',
      editDisabled: true,
      width: '100px',
    },
  ]
}